import { BankType, DebtType, OutDebt } from '../../generated/graphql';

export const transformInfoBank = (outDebt?: Pick<OutDebt, 'bank' | 'extra' | 'type'>) => {
  const { bank, extra, type } = outDebt || { bank: BankType.BancoDavivienda };
  const { daviplata, product } = extra || {};
  const isDav = bank === BankType.BancoDavivienda;
  const isDaviplata = isDav && daviplata;
  const bankEdited = isDaviplata ? 'DAVIPLATA' : bank;

  const isPayrollAdvance = product === 'ADELANTO NOMINA';

  let typeEdited: string = type!;
  if (isDaviplata) typeEdited = 'Nanocrédito';
  if (isPayrollAdvance && isDav) typeEdited = DebtType.PayrollAdvance;

  return {
    bank: bankEdited,
    type: typeEdited,
  };
};
